module.exports = __webpack_public_path__ + "img/hakuna_bg02.ba72390b.jpg";